/* @jsx h */
import { defineComponent, ref, h } from "vue";
import { LemmonModal } from "@lemmonhq/uikit";
import { useLocalization } from "@lemmonhq/uikit";
import { useAuth } from "../../providers/Auth";

interface CardModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (amountReceived: number, tipAmount?: number) => void;
  totalAmount: number;
}

export const CardModal = defineComponent<CardModalProps>({
  name: "CardModal",
  props: ["isOpen", "onClose", "onConfirm", "totalAmount"],
  setup(props) {
    const { t } = useLocalization();
    const auth = useAuth();
    const amountReceived = ref("");

    const handleSubmit = (e: Event) => {
      e.preventDefault();
      const amount = parseFloat(amountReceived.value);
      if (Number.isFinite(amount) && amount < props.totalAmount) {
        alert(
          `Amount received should be greater than ${props.totalAmount.toFixed(
            2,
          )} ${auth.user.value?.restaurant.currency || "CHF"}`,
        );
        return;
      }
      const rcvdAmount = amount || props.totalAmount;
      props.onConfirm(
        Number(amountReceived.value) || props.totalAmount,
        rcvdAmount - props.totalAmount,
      );
      props.onClose();
    };

    return () =>
      !props.isOpen ? null : (
        <div>
          <LemmonModal
            title={t("pos.pay.card_payment")}
            onClose={props.onClose}
            renderButtons={() => (
              <div class="p-4 border-t ">
                <div class="flex justify-between gap-2">
                  <button
                    onClick={() => props.onClose()}
                    class="btn btn-neutral"
                    type="button"
                  >
                    {t("general.words.cancel")}
                  </button>
                  <button
                    class="btn btn-primary"
                    type="submit"
                    disabled={false}
                    onClick={handleSubmit}
                  >
                    {t("pos.pay.pay_button")}
                  </button>
                </div>
              </div>
            )}
          >
            <div class="space-y-6">
              <div class="flex flex-col gap-0 text-accent">
                <div class="border-b  flex py-6 px-4">
                  <div class="flex-1 font-semibold flex items-center text-1xl">
                    {t("pos.pay.due_amount")}
                  </div>
                  <div class="flex-1 text-1xl text-right">
                    {auth.user.value?.restaurant.currency || "CHF"}{" "}
                    {props.totalAmount.toFixed(2)}
                  </div>
                </div>
                <div class="border-b  flex py-6 px-4">
                  <div class="flex-1 flex font-semibold items-center text-1xl">
                    {t("pos.pay.amount_received")}
                  </div>
                  <label class="flex-1 form-control w-full">
                    <input
                      type="number"
                      v-model={amountReceived.value}
                      class="input input-bordered w-full text-3xl"
                      step="0.01"
                      min={props.totalAmount}
                      placeholder="0.00"
                    />
                  </label>
                </div>
              </div>
            </div>
          </LemmonModal>
        </div>
      );
  },
});
